import { useQuery } from '@tanstack/react-query';
import factoryFloorDisplayService, {
  type FactoryFloorWorkOrdersResponse,
} from '../services/factoryFloorDisplay.service';
import type { ApiResponse } from '@/types';

export const FACTORY_FLOOR_QUERY_KEY = 'factory-floor' as const;

const unwrap = (res: ApiResponse<FactoryFloorWorkOrdersResponse>) => res.data?.work_orders ?? [];

export function useFactoryFloorDisplay(refetchInterval = 30000) {
  return useQuery({
    queryKey: [FACTORY_FLOOR_QUERY_KEY, 'work-orders'],
    queryFn: async () => unwrap(await factoryFloorDisplayService.getWorkOrders()),
    refetchInterval,
  });
}
